import React from "/vendor/react";
import PropTypes from "prop-types";

import {
  DeleteMenuItem,
  EditMenuItem,
} from "/lib/component/partial/ToolbarMenuItems";

import ConfirmDelete from "/lib/component/partial/ConfirmDelete";
import Toolbar from "/lib/component/partial/Toolbar";
import ToolbarMenu from "/lib/component/partial/ToolbarMenu";

const HandlerDetailsToolbar = ({
  handler,
  toolbarItems,
  onClickEdit,
  onClickDelete,
}) => (
  <Toolbar
    right={
      <ToolbarMenu>
        {toolbarItems({
          items: [
            <ToolbarMenu.Item key="edit" visible="always">
              <EditMenuItem onClick={onClickEdit} />
            </ToolbarMenu.Item>,
            <ToolbarMenu.Item key="delete" visible="if-room">
              {menu => (
                <ConfirmDelete
                  identifier={(handler || {}).name}
                  onSubmit={() => {
                    onClickDelete();
                    menu.close();
                  }}
                >
                  {dialog => (
                    <DeleteMenuItem
                      autoClose={false}
                      title="Delete…"
                      onClick={dialog.open}
                    />
                  )}
                </ConfirmDelete>
              )}
            </ToolbarMenu.Item>,
          ],
        })}
      </ToolbarMenu>
    }
  />
);

HandlerDetailsToolbar.propTypes = {
  handler: PropTypes.object,
  toolbarItems: PropTypes.func,
  onClickEdit: PropTypes.func,
  onClickDelete: PropTypes.func,
};

HandlerDetailsToolbar.defaultProps = {
  handler: null,
  toolbarItems: ({ items }) => items,
  onClickEdit: () => null,
  onClickDelete: () => null,
};

export default HandlerDetailsToolbar;
